import React, { useState } from 'react';
import "./DeleteProjectGroup.css";
import { projectGroupDelete } from '../../../api/project/projectApi'; // 🔸 실제 API 경로 맞게 수정하세요

const DeleteProjectGroup = ({ projectGroupId, projectName, onClose, onSuccess }) => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!password) {
      alert('프로젝트 비밀번호를 입력해주세요.');
      return;
    }

    const confirmDelete = window.confirm(`정말 "${projectName}" 프로젝트를 삭제하시겠습니까?`);
    if (!confirmDelete) return;

    try {
      setLoading(true);
      const response = await projectGroupDelete(projectGroupId, password);
      
      if (response?.status === 200) {
        alert('프로젝트가 성공적으로 삭제되었습니다.');
        if (onSuccess) onSuccess(); // ✅ 리스트 갱신 트리거
        onClose(); // 닫기
      } else {
        alert(response?.data?.message || '삭제에 실패했습니다.');
      }
    } catch (error) {
      console.error('프로젝트 삭제 오류:', error);
      alert(error.response?.data?.message || '삭제 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='DeleteProject_Container'>
      <div className='DeleteProject_TitleBox'>
        프로젝트 삭제
      </div>
    
      <div className='DeleteProject_NameContainer'>
        <div className='DeleteProject_NameBox'>
          프로젝트 비밀번호
        </div>
        <input  
          type='password' 
          className='DeleteProject_NameTextFelid'
          placeholder="프로젝트 비밀번호를 입력하세요"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={loading}
        />
      </div>
    
      <div className='DeleteProject_BtnContainer'>
        <div 
          className='DeleteProject_Btn DeleteProject_Btn_Delete'
          onClick={handleDelete}
        >
          {loading ? '삭제 중...' : '삭제'}
        </div>
        <div 
          className='DeleteProject_Btn DeleteProject_Btn_Cancel' 
          onClick={onClose}
        >
          취소
        </div>
      </div>
    </div>
  );
};

export default DeleteProjectGroup;
